/** Pure game-logic types. Nothing in src/core may import from pixi.js or the DOM. */
export const TILE_KINDS = ['latte', 'croissant', 'cupcake', 'macaron', 'donut', 'cookie'] as const;
export type TileKind = (typeof TILE_KINDS)[number];

/**
 * stripeH clears its row, stripeV its column, bomb a 3×3 area,
 * colorstar every tile of one kind (it has no kind itself).
 */
export type Special = 'stripeH' | 'stripeV' | 'bomb' | 'colorstar';

export interface Pos {
  row: number;
  col: number;
}

export interface Piece {
  /** unique per game, lets the renderer follow a piece through falls */
  id: number;
  /** null only for the colorstar */
  kind: TileKind | null;
  special: Special | null;
}

export interface Blocker {
  type: 'mud';
  /** hits left: 2 = thick mud, 1 = thin mud */
  hp: number;
}

export interface Cell {
  /** not part of the board (for shaped levels) */
  hole: boolean;
  piece: Piece | null;
  /** mud replaces the piece, does not fall, is damaged by nearby matches */
  blocker: Blocker | null;
  /** paw stain under the piece, removed when a piece on it is cleared */
  stain: boolean;
}

/** Board contents for simple rendering: grid[row][col], null = empty/hole. */
export type Grid = (TileKind | null)[][];

export const samePos = (a: Pos, b: Pos) => a.row === b.row && a.col === b.col;
export const isAdjacent = (a: Pos, b: Pos) => Math.abs(a.row - b.row) + Math.abs(a.col - b.col) === 1;
export const posKey = (p: Pos) => p.row * 64 + p.col;
